// Notärzte aus den eingelesenen Notarztplänen der Standorte (rddp) ohne Portal-Konto.
// Daten: GET naplan_nicht_angemeldet, Ausblenden: POST naplan_ignorieren {schluessel, ignorieren}
import { Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { format } from "date-fns";
import { useGlobal } from 'reactn';
import { DataTable } from "./datatable";

const datum = (iso) => {
    const d = new Date(iso)
    return isNaN(d) ? iso : format(d, 'd.M.y')
}

export function NaplanFehlend({ rows, reload }) {
    const [axios] = useGlobal('axios')

    const umschalten = (p) => {
        axios.post('naplan_ignorieren', { schluessel: p.schluessel, ignorieren: !p.ignoriert }).then(() => reload())
    }

    const columns = [
        { id: 'name', label: 'Name', get: p => p.name,
          render: p => <span style={{ opacity: p.ignoriert ? 0.5 : 1 }}><b>{p.vornamen.join(' / ')} {p.name}</b>
              {p.namen.length > 1 && <Typography component='span' variant='caption'> ({p.namen.join(', ')})</Typography>}</span> },
        { id: 'standorte', label: 'Standorte', get: p => p.standorte.join(', '),
          render: p => <Stack direction='row' spacing={0.5}>{p.standorte.map(s => <Chip key={s} size='small' label={s}/>)}</Stack> },
        { id: 'dienste', label: 'Dienste', get: p => p.dienste, align: 'right' },
        { id: 'erster', label: 'Erster Dienst', get: p => p.erster, render: p => datum(p.erster), hideBelow: 'sm', nowrap: true },
        { id: 'letzter', label: 'Letzter Dienst', get: p => p.letzter, render: p => datum(p.letzter), nowrap: true },
        { id: 'aktionen', label: '', sortable: false, align: 'right', width: 60, get: p => '', render: p =>
            <Tooltip title={p.ignoriert ? 'wieder einblenden' : 'ausblenden (kein Notarzt / Tippfehler)'}>
                <IconButton size='small' onClick={() => umschalten(p)}>
                    {p.ignoriert ? <Visibility fontSize='small'/> : <VisibilityOff fontSize='small'/>}
                </IconButton>
            </Tooltip> },
    ]

    return (
        <>
            <Typography variant='body2' sx={{ mb: 1 }}>
                Personen mit Diensten in den per Mail eingelesenen Notarztplänen, zu denen es kein Portal-Konto gibt (Abgleich über den Nachnamen, standortübergreifend).
            </Typography>
            <DataTable columns={columns} rows={rows} rowKey={p => p.schluessel}
                defaultSort='letzter' defaultDir='desc'
                searchLabel='Name, Standort'
                searchFields={[p => p.namen.join(' '), p => p.vornamen.join(' '), p => p.standorte.join(' ')]}
                filters={{ options: [{value:'offen',label:'offen'},{value:'ignoriert',label:'ausgeblendet'},{value:'alle',label:'alle'}],
                           match: (p,v) => v === 'alle' || (v === 'ignoriert' ? p.ignoriert : !p.ignoriert) }}
                emptyText='Keine Notärzte ohne Portal-Konto'/>
        </>
    )
}
